<div class="st-topic-custom-fields-header">{{ languageSettings.PSTWebCustomizeTopicCard }}</div>
<div class="st-topic-custom-fields-body">
    <st-topic-item
        [data]="data()"
        [cardViewType]="cardViewType()"
        [attr.small]="cardViewType() === CardViewType.SMALL"
        [isReadOnly]="true"
        [preview]="true"
        [customCardItems]="viewStateCustomCardItems()"
        [class.has-dynamic-controls]="true" />
    <div class="st-topic-custom-fields-body-field-container">
        <st-combo-box
            class="st-topic-custom-fields-body-field-container-field"
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="customFieldValue0()"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 0)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="customFieldValue1()"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 1)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="customFieldValue2()"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 2)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="customFieldValue3()"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 3)" />
    </div>
</div>
<div class="st-topic-custom-fields-footer">
    <button
        mat-button
        class="st-topic-custom-fields-cancel-btn"
        color="secondary"
        (click)="cancel()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="apply()">
        {{ languageSettings.PSTWebApplyButtonLabel }}
    </button>
    @if (isSuperVisor) {
        <button
            mat-raised-button
            color="primary"
            (click)="saveAsTeamDefault()">
            {{ languageSettings.PSTWebSaveAsTeamDefault }}
        </button>
    }
    @if (isSuperVisor) {
        <button
            mat-raised-button
            color="primary"
            (click)="saveAsEnterpriseDefault()">
            {{ languageSettings.PSTWebSaveAsEnterpriseDefault }}
        </button>
    }
</div>
